import {Injectable} from '@angular/core';
import {AbstractHttpService} from './abstract-http-service';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {catchError} from 'rxjs/operators';
import {AccountInventoryField} from '../model/account-inventory-field';
import {Observable} from 'rxjs';
import {InventoryFieldModel} from '../model/inventory-field.model';
import {InventoryMappingRequestModel} from '../model/inventory-mapping-request.model';

@Injectable({
  providedIn: 'root'
})
export class InventoryMappingService extends AbstractHttpService {
  defaultOptions = {
    headers: this.acceptJsonHeaders,
    withCredentials: true
  };

  resetMappingHeaders = {
    headers: this.contentTypeFormUrlEncodedHeaders,
    withCredentials: true
  };

  constructor(private httpClient: HttpClient) {
    super();
  }

  /** Returns persisted mappings after server-side source visibility filtering. */
  public getInventoryMappingFields(accountId: number): Observable<AccountInventoryField[]>
  {

    return this.httpClient.get<AccountInventoryField[]>(
      `//${environment.autoDomain}:${environment.autoPort}/api/inventory-mapping-fields?accountId=${accountId}`,
      this.defaultOptions
    ).pipe(
      catchError(this.handleError)
    );
  }

  /** Uses the server-filtered catalog for available mapping choices. */
  public getInventoryFields(): Observable<InventoryFieldModel[]>
  {

    return this.httpClient.get<InventoryFieldModel[]>(
      `//${environment.autoDomain}:${environment.autoPort}/api/inventory-fields`,
      this.defaultOptions
    ).pipe(
      catchError(this.handleError)
    );
  }

  /** Feed headers still use the legacy endpoint until LC-11491 migrates it. */
  public getInventoryHeaders(accountId: number): Observable<string[]>
  {

    return this.httpClient.get<string[]>(
      `/includes/ajax/mpop-api/inventory/get-inventory-headers/${accountId}/inventory`,
      this.defaultOptions
    ).pipe(
      catchError(this.handleError)
    );
  }

  /** Keeps explicit reset semantics on the legacy endpoint pending LC-11491. */
  public resetInventoryMapping(accountId: number): Observable<unknown>
  {

    return this.httpClient.put<unknown>(
      `/includes/ajax/api/accounts/${accountId}/settings/inventory-mappings?reset=true`,
      {},
      this.resetMappingHeaders
    ).pipe(
      catchError(this.handleError)
    );
  }

  /** Sends numeric deletion IDs while leaving hidden saved mappings to the server. */
  public updateInventoryMapping(inventoryMappingRequestModel: InventoryMappingRequestModel): Observable<unknown>
  {

    return this.httpClient.put<unknown>(
      `//${environment.autoDomain}:${environment.autoPort}/api/inventory-mapping-fields`,
      inventoryMappingRequestModel,
      this.defaultOptions
    ).pipe(
      catchError(this.handleError)
    );
  }
}
